/* eslint-disable array-callback-return */
import React, { useState, useEffect } from "react";
// import { Bar } from "react-chartjs-2";
import PropTypes from "prop-types";
import Chart from "react-apexcharts";

import Card from "../../../component/card/Card";

// const colors = [
//   "#666699",
//   "#000099",
//   "#669999",
//   "#336600",
//   "#FFE652",
//   "#336699"
// ];

const initialState2 = {
  apexProjectWorkerOptions: {
    chart: {
      height: 350,
      type: "bar",
      stacked: false
    },
    zoom: {
      enabled: true
    },
    stroke: {
      width: 2,
      show: true
    },
    title: {
      text: "Location vs Daily Employees",
      align: "left",
      offsetX: 110
    },
    plotOptions: {
      bar: {
        columnWidth: "45%",
        distributed: true
      }
    },
    dataLabels: {
      enabled: true
    },
    xaxis: {
      categories: [],
      labels: {
        style: {
          // colors: colors,
          fontSize: "12px"
        }
      }
    },
    yaxis: [
      {
        axisTicks: {
          show: true
        },
        axisBorder: {
          show: true,
          color: "#008FFB"
        },
        labels: {
          style: {
            colors: "#008FFB"
          }
        },
        title: {
          text: "Total (Location vs Employees)",
          style: {
            color: "#008FFB"
          }
        },
        tooltip: {
          fixed: {
            enabled: true,
            position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
            offsetY: 30,
            offsetX: 60
          }
        },
        legend: {
          horizontalAlign: "left",
          offsetX: 40
        }
      }
    ]
  },
  apexProjectWorkerSeries: [
    {
      data: []
    }
  ]
};

const AttendanceGraph = ({ dailyAttendanceLocationWiseGraph }) => {
  const [attendanceGraph, setAttendanceGraph] = useState(
    initialState2
  );

  useEffect(() => {
    if (dailyAttendanceLocationWiseGraph !== null) {
      const bar_label = [];
      const presentData = [];
      // const absentData = [];
      const workerFootfallSortedData = dailyAttendanceLocationWiseGraph.sort(
        (a, b) => {
          return a.count - b.count;
        }
      );

      workerFootfallSortedData.map((dailyData, index) => {
        if (dailyData._id !== null) {
          bar_label.push(dailyData._id);
          presentData.push(dailyData.count);
          // absentData.push(dailyData.absentCount);
          setAttendanceGraph({
            ...attendanceGraph,
            apexProjectWorkerOptions: {
              xaxis: {
                categories: bar_label
              }
            },
            apexProjectWorkerSeries: [
              {
                name: "Total Present",
                data: presentData
              }
              // {
              //   name: "Absent",
              //   data: absentData
              // }
            ]
          });
        }
      });
    }
  }, [dailyAttendanceLocationWiseGraph]);

  return (
    <Card>
      <Chart
        options={attendanceGraph.apexProjectWorkerOptions}
        series={attendanceGraph.apexProjectWorkerSeries}
        type="bar"
        height={410}
      />
    </Card>
  );
};

AttendanceGraph.propTypes = {
  dailyAttendanceLocationWiseGraph: PropTypes.array.isRequired
};

export default AttendanceGraph;
